export const API_PAYOUT_ROUTES = Object.freeze({
    PAYOUTS: '/payout',
});
